import { modelSideUrl, type VehicleModel } from "../../../config/vehicleModels";

// La carátula del vehículo "parada en un piso", como en el garaje de un juego:
// luz suave desde abajo + sombra de contacto bajo las llantas. Sin eso la
// imagen flotaba y se leía como un PNG pegado encima de la tarjeta.
export default function VehicleStage({
  model,
  size,
  isDarkMode,
  className = "",
  onEdit,
}: {
  model: VehicleModel;
  /** hero = escenario grande; chip = losa compacta junto al nombre. */
  size: "hero" | "chip";
  isDarkMode: boolean;
  className?: string;
  /** Lápiz para abrir el garaje (cambiar el vehículo). */
  onEdit?: () => void;
}) {
  const hero = size === "hero";
  const light = isDarkMode
    ? "radial-gradient(90% 85% at 50% 100%, rgba(255,255,255,0.10), rgba(255,255,255,0.02) 55%, transparent 75%)"
    : "radial-gradient(90% 85% at 50% 100%, rgba(15,23,42,0.07), rgba(15,23,42,0.02) 55%, transparent 75%)";
  return (
    <div
      className={`relative overflow-hidden ${hero ? "h-[112px]" : "w-16 h-11 rounded-lg"} ${
        hero ? "" : isDarkMode ? "bg-white/[0.04] ring-1 ring-inset ring-white/5" : "bg-gray-50 ring-1 ring-inset ring-black/5"
      } ${className}`}
      style={{ backgroundImage: light }}
      title={model.name}
    >
      {/* Sombra de contacto: elíptica, oscura al centro y difuminada. */}
      <span
        aria-hidden
        className="absolute left-1/2 -translate-x-1/2 rounded-[50%]"
        style={{
          bottom: hero ? 12 : 4,
          width: hero ? "58%" : "72%",
          height: hero ? 12 : 5,
          background: "radial-gradient(closest-side, rgba(0,0,0,0.55), rgba(0,0,0,0))",
          filter: `blur(${hero ? 3 : 1}px)`,
        }}
      />
      <img
        src={modelSideUrl(model.id)}
        alt={model.name}
        loading="lazy"
        draggable={false}
        className="absolute left-1/2 -translate-x-1/2 object-contain select-none"
        // El borde inferior de la imagen son las llantas: apoyarlas sobre la
        // sombra (bottom un poco menor que el de la sombra + su alto/2).
        style={{ bottom: hero ? 14 : 6, height: hero ? 88 : 28, maxWidth: hero ? "86%" : "90%", imageRendering: model.pixel ? "pixelated" : undefined }}
      />
      {onEdit && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
          aria-label="Cambiar vehículo"
          title="Cambiar vehículo"
          className={`absolute right-0.5 top-0.5 w-5 h-5 rounded-md flex items-center justify-center transition-colors ${
            isDarkMode ? "bg-black/55 text-white/80 hover:text-white hover:bg-black/75" : "bg-white/90 text-gray-600 hover:text-gray-900 shadow-sm"
          }`}
        >
          <i className="ri-pencil-line text-[11px] leading-none" aria-hidden />
        </button>
      )}
    </div>
  );
}
